// extracted by mini-css-extract-plugin
module.exports = {"editor":"editor_editor__CInC5","readOnly":"editor_readOnly__SqvG_","focus":"editor_focus__obwNU","licenseInput":"editor_licenseInput___OgmN"};